import { Button, Col, Form, Row, Select } from "antd";
import moment from "moment";
import { useEffect } from "react";
import api from "../../services/api";
import { BreadcrumbPage, Data, GerarEfdPisCofins } from "../../components";
import { useState } from "react";
import maskFormat from "../../ValueObjects/maskFormat";
import { CloseOutlined, SaveOutlined } from "@ant-design/icons";

export default function EfdPisCofins() {

    const [formulario] = Form.useForm();
    const [dadosLocais, setDadosLocais] = useState([]);
    const [listaFinalidadeArquivo, setListaFinalidadeArquivo] = useState([]);
    const [carregando, setCarregando] = useState(false);

    useEffect(() => {
        carregandoDados();
        setMonthDates();
    }, [])


    const setMonthDates = () => {
        formulario.setFieldsValue({
            dataInicial: moment().startOf('month'),
            dataFinal: moment().endOf('month')
        });
    };

    function carregandoDados() {
        api.get('Local/Listar?Ativo=true').then(
            res => {
                setDadosLocais(res.data?.items);
            }
        ).catch(
            error => {
                console.log(error);
            }
        )
    }


    function gerarEfdPisCofins() {
        let sql = "";
        sql += !!formulario.getFieldValue().local ? `Local=${formulario.getFieldValue().local}` : ``;
        sql += !!formulario.getFieldValue().dataInicial ? `&DataInicial=${moment(formulario.getFieldValue().dataInicial).format('YYYY-MM-DD')}` : `&dataInicial=${moment(new Date()).format('YYYY-MM-DD')}`;
        sql += !!formulario.getFieldValue().dataFinal ? `&DataFinal=${moment(formulario.getFieldValue().dataFinal).format('YYYY-MM-DD')}` : `&dataFinal=${moment(new Date).format('YYYY-MM-DD')}`;



        setCarregando(true);
        api.get(`EfdPisCofins/GerarEfdPisCofins?` + sql, { responseType: 'blob' })
            .then(res => {
                // Log para verificar os headers
                console.log(res.headers);

                // Extrair o Content-Disposition
                const contentDisposition = res.headers['content-disposition'];
                let filename = 'SPED.txt'; // Nome padrão

                if (contentDisposition) {
                    // Tentar extrair o nome do arquivo da maneira mais robusta possível
                    const filenameMatch = contentDisposition.match(/filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/);
                    if (filenameMatch && filenameMatch[1]) {
                        filename = filenameMatch[1].replace(/['"]/g, ''); // Remover aspas
                    } else {
                        // Tentar a variante filename*
                        const utfFilenameMatch = contentDisposition.match(/filename\*\s*=\s*UTF-8''(.+)/);
                        if (utfFilenameMatch && utfFilenameMatch[1]) {
                            filename = decodeURIComponent(utfFilenameMatch[1]);
                        }
                    }
                }

                // Cria o blob e dispara o download com o nome extraído
                const blob = new Blob([res.data], { type: 'application/txt' });
                const link = document.createElement('a');
                link.href = URL.createObjectURL(blob);
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                link.remove();
                setCarregando(false);
            })
            .catch(erro => {
                console.log(erro);
            }).finally(
                () => {
                    setCarregando(false);
                }
            );

    };


    return (
        <div className="p-10">
            <Row align="middle" justify="space-between" gutter={[8, 0]} className="col-pagina-breadcrumb">
                <Col className="col-w-100">
                    <BreadcrumbPage />
                </Col>
            </Row>
            <Form layout="vertical" form={formulario} name="listaEfdIcmsIpi" onFinish={gerarEfdPisCofins} initialValues={{ remember: true }}>
                <Row gutter={[8, 0]}>
                    <Col xs={24} sm={24} md={14} lg={14} xl={6} xxl={6} >
                        <Form.Item
                            label="Local"
                            name="local"
                            rules={[{ required: true, message: 'Informe Local da Geração' }]}
                        >
                            <Select
                                showSearch
                                allowClear
                                optionFilterProp="label"
                                placeholder="Selecione uma Local"
                                filterSort={(optionA, optionB) =>
                                    (optionA?.label ?? '').toLowerCase().localeCompare((optionB?.label ?? '').toLowerCase())
                                }
                                optionLabelProp="label" // Define que o label será usado para filtragem e exibição no dropdown
                            >
                                {dadosLocais.map((l) => (
                                    <Select.Option
                                        key={l.loc_id}
                                        value={l.loc_id}
                                        label={l.loc_descricao} // Para filtragem e visualização no dropdown
                                    >
                                        {l.loc_descricao}  {/* Exibe o loc_id na interface */}
                                        {(!!l.loc_cnpj ? <div>{maskFormat(l.loc_cnpj.numero, '', true)}</div> : '')}
                                    </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </Col>
                    <Col xs={24} sm={12} md={5} lg={5} xl={3} xxl={3}>
                        <Data label="Data Inicial" name="dataInicial" rules={[{ required: true, message: 'Informe a Data Inicial da Geração' }]} />
                    </Col>
                    <Col xs={24} sm={12} md={5} lg={5} xl={3} xxl={3}>
                        <Data label="Data Final" name="dataFinal" rules={[{ required: true, message: 'Informe a Data Final da Geração' }]} />
                    </Col>
                    <Col xs={24} sm={12} md={9} lg={9} xl={6} xxl={6}>
                        <Form.Item label="Tipo de Escrituração" name="finalidade" initialValue={0} rules={[{ required: true, message: 'Informe o Tipo de Escrituração' }]}>
                            <Select
                                showSearch
                                allowClear
                                optionFilterProp="label"
                                placeholder="Selecione o Tipo de Escrituração"
                            >
                                {listaFinalidadeArquivo.map((c) => (
                                    <Select.Option
                                        key={c.key}
                                        value={c.key}
                                        label={c.value}
                                    >
                                        {c.value} </Select.Option>
                                ))}
                            </Select>
                        </Form.Item>

                    </Col>
                </Row>
                <Row align="middle" justify="end" gutter={[8, 0]} className="ant-drawer-footer footer-recebimento contador-media">
                    <Col>
                        <Button icon={<CloseOutlined />} size="large">
                            Cancelar
                        </Button>
                    </Col>
                    <Col>
                        <GerarEfdPisCofins type="primary" icon={<SaveOutlined />} loading={carregando} size="large" htmlType="submit" onClick={gerarEfdPisCofins}>
                            Gerar
                        </GerarEfdPisCofins>
                    </Col>
                </Row>
            </Form>
        </div >
    );
}
